var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section one-column-text-with-background-panel content-panel"},[(_vm.data)?_c('div',{staticClass:"rebrandContainerRedesign",domProps:{"innerHTML":_vm._s(_vm.data.htmlScriptTag)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }